import { LANGUAGES } from 'projects/core/src/lib/constants';
import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { ExercisepartModel } from './exercisepart.model';
import { ExerciseversionModel } from './exerciseversion.model';
import { ElementModel } from './element.model';
import { BehavioranchorModel } from './behavioranchor.model';
import { AcStatusSettingsExerciseType } from 'projects/runner/src/app/models/acstatus/ac-status.type';

export enum ExerciseType {
  Individual = 'individual',
  Team = 'team',
}

export const EXERCISETYPES = {
  individual: 'common.labels.individual',
  team: 'common.labels.team',
}

export class ExerciseModel extends BaseModel implements Deserializable {

  // columns
  status: string;
  for_single: boolean;
  for_group: boolean;
  name: string;
  title: string;
  language: string;
  description: string;
  hashed_id: string; // tslint:disable-line: variable-name
  ac_amount?: number;
  group_settings: { [key: string]: any }; // tslint:disable-line: variable-name

  // relations
  elements: Array<ElementModel>;
  behavioranchors: Array<BehavioranchorModel> = [];
  exerciseparts: Array<ExercisepartModel>;
  versions: Array<ExerciseversionModel>;

  deserialize(input: any): this {
    Object.assign(this, input);
    // elements
    let elements = null;
    if (this.elements !== null && this.elements !== undefined) {
      elements = [];
      this.elements.forEach((element: ElementModel) => {
        elements.push(new ElementModel().deserialize(element));
      });
    }
    this.elements = elements;
    // behavioranchors
    let behavioranchors = null;
    if (this.behavioranchors !== null && this.behavioranchors !== undefined) {
      behavioranchors = [];
      this.behavioranchors.forEach((behavioranchor: BehavioranchorModel) => {
        behavioranchors.push(new BehavioranchorModel().deserialize(behavioranchor));
      });
    }
    this.behavioranchors = behavioranchors;
    // exerciseparts
    let exerciseparts = null;
    if (this.exerciseparts !== null && this.exerciseparts !== undefined) {
      exerciseparts = [];
      this.exerciseparts.forEach((exercisepart: ExercisepartModel) => {
        exerciseparts.push(new ExercisepartModel().deserialize(exercisepart));
      });
    }
    this.exerciseparts = exerciseparts;
    // versions
    let versions = null;
    if (this.versions !== null && this.versions !== undefined) {
      versions = [];
      this.versions.forEach((exerciseversion: ExerciseversionModel) => {
        versions.push(new ExerciseversionModel().deserialize(exerciseversion));
      });
    }
    this.versions = versions;
    return this;
  }

  public get is_active(): boolean {
    return this.status === 'active';
  }

  public getLanguageName(): string {
    return (this.language) ? LANGUAGES[this.language] : '';
  }

  public getTypeName(): string {
    return (this.transloco && this.group_settings?.type) ? this.transloco.translate('common.labels.' + this.group_settings.type) : '';
  }

  public forSingle(): boolean {
    return this.for_single === true;
  }

  public forGroup(): boolean {
    return this.for_group === true;
  }

  public isIndividual(): boolean {
    return this.forGroup() && this.group_settings?.type === ExerciseType.Individual;
  }

  public isTeam(): boolean {
    return this.forGroup() && this.group_settings?.type === ExerciseType.Team;
  }

  public getMinCandidatesPerTeam(): number | null {
    return parseInt(this.group_settings?.min_candidates_per_team) || null;
  }

  public getMinObserversPerCandidate(): number | null {
    return parseInt(this.group_settings?.min_observers_per_candidate) || null;
  }

  public hasOverlapping(): boolean {
    return this.group_settings?.overlapping === true;
  }

  public hasAcs(): boolean {
    return this.ac_amount > 0;
  }

  public shouldShowInheritDialog(): boolean {
    return this.hasAcs();
  }

}
